<template>

    <div :id="pageId + 'Page'" class="ciam-page">
      <div class="logo-container"><img :src="Logo" alt="logo" width="70" height="70" class="brand-logo"/></div>
        <slot name="before"></slot>
        <div id="pageContent" class="ui aligned center grid ciam-content">
            <div id="pageColumn" class="ui column">
                <form v-on:submit.prevent="doNothing" :id="pageId+'Form'" action="#" method="post" class="ui custom-ui form error">
                    <div class="ui custom-ui segment">
                        <loader :activate-on="loading"></loader>

                        <slot>page content</slot>

                    </div>
                </form>

            </div>
        </div>

        <div id="footer" class="ciam-footer">
            <legal-notices :modal-id="pageId" :active="!loading"></legal-notices>
        </div>
    </div>
</template>

<script>
import Loader from '../../components/Loader.vue'
import LegalNotices from '../../components/toas/LegalNotices.vue'
import { mixin } from '../../js/ciam-mixin.js'
import Logo from '../../assets/logos/svg/MB-star_n_2D_3Cweb.svg'

export default {
  components: { Loader, LegalNotices },
  mixins: [mixin],
  props: {
    pageId: String
  },
  data: function () {
    return {
      loading: false,
      Logo
    }
  },
  methods: {
    setLoading: function (val) {
      this.loading = val
    },
    startLoading: function () {
      this.loading = true
    },
    stopLoading: function () {
      this.loading = false
    },
    disableIfLoading: function () {
      if (this.loading) this.loading = false
    },
    doNothing: function () {
      return false
    }
  },
  mounted: function () {
    $('#brand-description')
      .popup({
        namespace: 'onclickpopup',
        hoverable: true,
        delay: {
          show: 300,
          hide: 300
        },
        position: 'bottom center',
        on: 'click'
      })
    this.disableIfLoading()
  }
}
</script>

<style>
    .ciam-page {
        width: 100%;
        max-width: 665px;
        height: auto;
        min-height: 100vh;
        margin: 0 auto;
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .ciam-content {
        padding-bottom: 40px !important; /* Height of the footer */
        margin-left: 0 !important;
        margin-right: 0 !important;
        background: white;
    }

    @media (min-width: 666px) {
        .ciam-page {
            justify-content: flex-start;
        }
    }

    @media (max-width: 665px) {
        .ciam-page {
            justify-content: flex-start;
            background: white;
        }

        .ciam-content {
            min-height: calc(100vh - 80px);
            padding-bottom: 80px !important;
            display: flex;
        }
    }

    .ciam-footer {
        font-size: 12px;
        color: #3088C5;
        text-align: center;
        background-color: transparent;

        /* sticky footer*/
        width: 100%;
        margin: 0;
        padding: 20px 0 26px;
        height: 60px; /* Height of the footer */
    }

    @media (min-width: 666px) {
        .ciam-footer {
            display: block;
            text-align: right;
            padding-bottom: 20px;
            padding-right: 26px;
            margin-bottom: 0;
            font-size: 12px;
            background-color: #000;
            width: 100%;
        }
    }

    @media (max-width: 665px) {
        .ciam-footer {
            position: absolute;
            bottom: 0;
            margin-top: 40px;
        }
    }

    .brand-logo {
      text-align: center;
      margin-top: 28px;
    }

    .logo-container {
      background-color: black;
      margin-left: -250px;
      margin-right: -250px;
      height: 130px;
      box-shadow: 10px 10px 30px rgba(0, 0, 1, 0.9);
    }
</style>
